import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

const funciones = [
  "Función 1",
  "Función 2",
  "Función 3",
  "Función 4",
  "Función 5"
];

const ValidadorDePedidos = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      {/* 🔹 Imagen de fondo */}
      <div className="fondo-validador">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo del Validador de Pedidos de Compra"
        />
        <div className="fondo-validador-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo-validador">Validador de Pedidos de Compra</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src={`/images/validadorpedidos1.jpg`}
          alt="Validador de Pedidos"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Optimiza el proceso de aprobación de compras con esta solución intuitiva. A través de un circuito de firmas digital, los usuarios pueden validar fácilmente las compras generadas en la aplicación.
          </p>
          <p>
            Despídete de los trámites lentos y engorrosos, y da la bienvenida a un flujo de trabajo más rápido, eficiente y totalmente digital.
          </p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>Funciones Destacadas</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✓ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/validadorpedidos${num}.jpg`}
                alt={`Validador de Pedidos ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/validadorpedidos${num}.jpg`}
              alt={`Validador de Pedidos ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>

      <section className="cta fade-in">
        <h2>Prueba el Validador de Pedidos Ahora</h2>
        <p>Empieza a optimizar la aprobación de pedidos con nuestro validador digital.</p>
        <button className="btn-cta">Solicitar una Demo</button>
      </section>
    </div>
  );
};

export default ValidadorDePedidos;
